module.exports = __webpack_public_path__ + "static/img/16areaA_2.ac0f4eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/16areaA_2.png
// module id = 888
// module chunks = 1